import { useState } from 'react'
import { type FormContextValue } from 'remix-validated-form'
import { aIsFormLocked, useSetAtom } from '~/atoms'
import { LoadingCircle } from '~/components'
import { AlertDialog, Button } from '~/components/ui'

export default function SubmitField({
  formContext,
  isUpdating,
  isDisabled,
  className,
  onSaveGuard,
  onComplete,
}: {
  formContext: FormContextValue
  isUpdating: boolean
  isDisabled?: boolean
  className?: string
  onSaveGuard?: () => string | null
  onComplete?: () => void
}) {
  const setIsFormLocked = useSetAtom(aIsFormLocked)
  const [alertMessage, setAlertMessage] = useState<string | null>(null)

  return (
    <div className={className}>
      <Button
        type="submit"
        disabled={formContext.isSubmitting || isDisabled}
        onClick={(e) => {
          const message = onSaveGuard && onSaveGuard()
          if (message) {
            setAlertMessage(message)
            e.preventDefault()
            e.stopPropagation()
          } else {
            setIsFormLocked(false)
            window.onbeforeunload = null
          }
          onComplete?.()
        }}>
        {formContext.isSubmitting && <LoadingCircle className="mr-2 h-5 w-5" />}
        {formContext.isSubmitting
          ? isUpdating
            ? 'Saving'
            : 'Creating'
          : isUpdating
            ? 'Save'
            : 'Create'}
      </Button>

      <AlertDialog open={!!alertMessage}>
        <AlertDialog.Content>
          <AlertDialog.Header>
            <AlertDialog.Title>Confirm Save</AlertDialog.Title>
            <AlertDialog.Description>{alertMessage}</AlertDialog.Description>
          </AlertDialog.Header>
          <AlertDialog.Footer>
            <AlertDialog.Cancel onClick={() => setAlertMessage(null)}>
              No
            </AlertDialog.Cancel>
            <AlertDialog.Action
              onClick={() => {
                setIsFormLocked(false)
                window.onbeforeunload = null
                setAlertMessage(null)
                formContext.submit()
              }}>
              Yes
            </AlertDialog.Action>
          </AlertDialog.Footer>
        </AlertDialog.Content>
      </AlertDialog>
    </div>
  )
}
